import { _js } from '@ifixit/localize';
import * as React from 'react';
import styled from 'styled-components';
import { color, space, fontSize, breakpoint } from '@core-ds/primitives';
import { Avatar, withBreakpoints, BreakpointsContext } from 'core-components';
import Dropdown from './dropdown';
import MenuButton from './menu_button';

declare global {
   interface Window {
      shared_constants: Record<string, any>;
   }
}

const Container = styled.div`
   text-align: left;
`;

const Icon = withBreakpoints(styled(Avatar)<{ breakpoints: any }>`
   cursor: pointer;
   width: ${props => (props.breakpoints.isDesktop() ? '32px' : '24px')};
   height: ${props => (props.breakpoints.isDesktop() ? '32px' : '24px')};
`);

const Section = styled.div<{ padding?: string }>`
   background: white;
   text-align: left;
   border-bottom: 1px solid ${color.gray[200]};
   padding: ${props => props.padding || space[2] + ' 0'};
`;

const Title = styled.h3`
   font-size: ${fontSize.lg};
   color: ${color.gray[900]};
   margin: 0;
`;

const Subtitle = styled.h3`
   font-size: ${fontSize.lg};
   font-weight: normal;
   color: ${color.gray[600]};
   margin-top: 8px;
`;

const UserDropdown = ({
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'username' implicitly has an 'any'... Remove this comment to see the full error message
   username,
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'uniqueUsername' implicitly has an... Remove this comment to see the full error message
   uniqueUsername,
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'profileUrl' implicitly has an 'an... Remove this comment to see the full error message
   profileUrl,
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'ordersUrl' implicitly has an 'any... Remove this comment to see the full error message
   ordersUrl,
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'notificationsUrl' implicitly has ... Remove this comment to see the full error message
   notificationsUrl,
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'avatar' implicitly has an 'any' t... Remove this comment to see the full error message
   avatar,
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'team' implicitly has an 'any' typ... Remove this comment to see the full error message
   team,
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'canIViewManageTab' implicitly has... Remove this comment to see the full error message
   canIViewManageTab,
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'notifications' implicitly has an ... Remove this comment to see the full error message
   notifications,
}) => {
   const breakpoints = React.useContext(BreakpointsContext);
   const unreadNotifications = notifications.getUnreadNotifications();

   return (
      <Dropdown
         icon={<Icon id="profileMenuToggle" src={avatar} aria-label="profile" focusable="false" />}
         hasBadge={breakpoints.isMobileTablet() && notifications.getUnreadCount()}
      >
         <Container>
            <Section padding={space[4]}>
               <Title>{username}</Title>
               {uniqueUsername && <Subtitle>&#x40;{uniqueUsername}</Subtitle>}
            </Section>
            <Section id="profileMenu">
               <MenuButton
                  url={notificationsUrl}
                  text={_js('Notifications')}
                  badge={notifications.getUnreadCount()}
               />
               <MenuButton id="myAccount" url={profileUrl} text={_js('View Profile')} />
               {team && (
                  <MenuButton
                     url={team.teamLink}
                     text={team.teamCount > 1 ? _js('My Teams') : _js('My Team')}
                  />
               )}
               <MenuButton url={ordersUrl} text={_js('Orders')} />
               {canIViewManageTab && <MenuButton url={'/Manage'} text={_js('Manage')} />}
            </Section>
            <Section>
               <MenuButton
                  id="navLogout"
                  url={window.shared_constants.GuideURI('TAG_LOGOUT')}
                  text={_js('Log Out')}
               />
            </Section>
         </Container>
      </Dropdown>
   );
};

export default UserDropdown;
